import { motion, AnimatePresence } from 'framer-motion'
import * as Styled from './styled'
import { Icon, Text } from 'common-components'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { TUploadType, UPLOAD_TYPES } from 'consts/uploadTypes'
import { extractFileExtensionsFromMimeTypes } from 'utils'
import WarningIcon from 'assets/svgr-icons/Warning.svg'

export const SupportedFileTypesBanner = ({
  acceptType,
  isWarningOpen
}: {
  acceptType: TUploadType
  isWarningOpen: boolean
}) => {
  const supportedFileTypes = extractFileExtensionsFromMimeTypes(
    UPLOAD_TYPES[acceptType]
  )

  return (
    <AnimatePresence>
      {isWarningOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20, height: 0 }}
          animate={{ opacity: 1, y: 0, height: 'auto' }}
          exit={{ opacity: 0, y: -20, height: 0 }}
          transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }}
        >
          <Styled.SupportedFileTypesBannerWrapper>
            <Icon icon={<WarningIcon />} size="small" color="accentRed" />
            <Text type="p" color="secondary">
              {translate(T.SUPPORTED_FILE_TYPES_WARNING)}
              <span style={{ fontWeight: '600' }}>{supportedFileTypes}</span>.
            </Text>
          </Styled.SupportedFileTypesBannerWrapper>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
